import React, { useEffect, useState } from "react";
import ImageCarousel from "../../../components/ImageCarousel";
import classes from "./index.module.css";
import AppLogo from "../../../assets/images/mainLogo.png";
import { api } from "../../../api-calls/user-requests";
import { pageLoader } from "../../../Redux/actions/user-actions";
import { SET_PASSWORD } from "../../../api-calls/api-urls";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import "../../../assets/css/style.css";
import { Card, Button, Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loggedUser } from "../../../Redux/actions/user-actions";
import { getLanguagedataFunction } from "../../../utilities/language";
import { CloseEyeIcon, OpenEyeIcon } from "../../../components/Icons";

const SetPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const [showPassword1, setShowPassword1] = React.useState(false);
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const regUser = JSON.parse(sessionStorage.getItem("CurrentUser"));
  const ln = useSelector((state) => state.allUsers.language_json);

  useEffect(() => {
    getLanguagedataFunction(dispatch);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!ln]);

  const handleSubmit = async () => {
    try {
      const userEntry = {
        user_id: regUser._id,
        password: password,
        confirm_password: confirmPassword,
      };
      dispatch(pageLoader(true));
      const { data } = await api.post(SET_PASSWORD, userEntry);
      dispatch(loggedUser(data));
      await sessionStorage.setItem("userInfo", JSON.stringify(data));
      navigate("/register-success");
    } catch (err) {
      console.log(err);
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const confirmPasswordValue = e.target.value;
    setConfirmPassword(confirmPasswordValue);
    setPasswordsMatch(password === confirmPasswordValue);
  };

  return (
    <div className={classes.maindivForlogin}>
      {ln ? (
        <Card className={classes.SelectLanguage_maindiv}>
          <div>
            <ImageCarousel />
          </div>
          <ValidatorForm
            useref="form"
            onSubmit={handleSubmit}
            className={classes.InputForm}
          >
            <Box sx={{ width: '100%' }}>
              <div style={{ padding: "3rem" }}>
                <div className="text-left">
                  <Box component="span" className="logo-lg" sx={{ mb: 6 }}>
                    <img src={AppLogo} alt="" height="50" />
                  </Box>
                  <Typography variant="h5" className={classes.loginHeading} sx={{ mt: 6 }}>
                    {ln.set_password}
                  </Typography>
                  <Typography className={classes.loginDescription} sx={{ mt: 3 }}>
                    {ln.please_set_your_password}
                  </Typography>
                </div>

                <Box sx={{ mt: 3 }}>
                  <Box sx={{ mb: 3 }}>
                    <label
                      htmlFor="userpassword"
                      className={classes.login_form_lable}
                    >
                      {ln.new_password}
                    </label>
                    <div className={classes.passwordInputContainer}>
                      <TextValidator
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        id="outlined-adornment-password"
                        type={showPassword ? "text" : "password"}
                        fullWidth
                        size="small"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        validators={[
                          "required",
                          "matchRegexp:^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-_]).{8,}$",
                        ]}
                        errorMessages={[
                          "Password is required",
                          "Password should contain 1 capital letter, 1 small letter, 1 number, 1 special characters  and should be 8 digits",
                        ]}
                      />
                      <div
                        className={classes.showPassword}
                        style={{ top: "-2px" }}
                      >
                        {showPassword ? (
                          <Button
                            variant="text"
                            onClick={() => setShowPassword(false)}
                          >
                            <OpenEyeIcon />
                          </Button>
                        ) : (
                          <Button
                            variant="text"
                            onClick={() => setShowPassword(true)}
                          >
                            <CloseEyeIcon />
                          </Button>
                        )}
                      </div>
                    </div>
                  </Box>

                  <Box sx={{ mb: 1 }}>
                    <label
                      htmlFor="userpassword"
                      className={classes.login_form_lable}
                    >
                      {ln.confirm_new_password}
                    </label>
                    <div className="auth-pass-inputgroup" style={{ position: 'relative', marginBottom: '1rem' }}>
                      <div className={classes.passwordInputContainer}>
                        <TextValidator
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          id="outlined-adornment-password"
                          type={showPassword1 ? "text" : "password"}
                          fullWidth
                          size="small"
                          value={confirmPassword}
                          onChange={handleConfirmPasswordChange}
                          validators={[
                            "required",
                            "matchRegexp:^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-_]).{8,}$",
                          ]}
                          errorMessages={[
                            "Confirm password is required",
                            "Password should contain 1 capital letter, 1 small letter, 1 number, 1 special characters  and should be 8 digits",
                          ]}
                          error={!passwordsMatch} // Set an error state if passwords don't match
                          helperText={
                            !passwordsMatch && "Passwords do not match"
                          }
                        />
                        <div
                          className={classes.showPassword}
                          style={{ top: "-2px" }}
                        >
                          {showPassword1 ? (
                            <Button
                              variant="text"
                              onClick={() => setShowPassword1(false)}
                            >
                              <OpenEyeIcon />
                            </Button>
                          ) : (
                            <Button
                              variant="text"
                              onClick={() => setShowPassword1(true)}
                            >
                              <CloseEyeIcon />
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </Box>

                    <Button
                      variant="contained"
                      className={classes.commonbtn}
                      fullWidth
                      type="submit"
                    >
                      {ln.continue}
                    </Button>
                </Box>
              </div>
            </Box>
          </ValidatorForm>
        </Card>
      ) : null}
    </div>
  );
};

export default SetPassword;
